module.exports = __webpack_public_path__ + "static/media/c2_2.de197ed7.png";